import React from 'react';
import PropTypes from 'prop-types';

const PaymentSummary = props => {
  const {employeesLength, amountToPay, bank, className} = props
  return (
    <div className={className}>
      <p className="s-mb-12px">Empleados seleccionados: <span className="s-color-blue">{employeesLength}</span></p>
      <p className="s-mb-12px">Total a pagar: <span className="s-color-blue">{amountToPay}</span></p>
      <p className="l-block">Empleados seleccionados: <span className="s-color-blue">{bank}</span></p>
    </div>
  );
};

PaymentSummary.propTypes = {
  employeesLength: PropTypes.number.isRequired,
  amountToPay: PropTypes.string.isRequired,
  bank: PropTypes.string.isRequired,
  className: PropTypes.string,
};

PaymentSummary.defaultProps = {
  className: '',
}

export default PaymentSummary;
